import React, { Component } from 'react';

class Banner extends Component {

  render() {

    return (
      <div className="contact-banner">
        <p>Contact me at <em>coding.malkio@gmail.com</em></p>
      </div>
    );
  }
}

export default Banner;



// WEBPACK FOOTER //
// ./src/components/layout/Banner.js